module.exports = __webpack_public_path__ + "img/maimonides.671b51f4.webp";